import { immutableReplace } from '../../lib/arrayOperations'

import {
    APP_SET_SEARCH,
    APP_UPDATE_ATTRIBUTE,
    HANDLE_CHANGE,
    SET_USER_ATTRIBUTES,
    SET_USER_DATA,
    SHOW_UPDATE_ATTRIBUTES,
    SHOW_BUILDING_PICKER,
    UPDATE_TRAINING_RESULT,
    UPDATE_WINDOW_DIMENSIONS,
    UPDATE_BUILDING_DATA,
    APP_TOGGLE_ADMIN_MODE,
    UPDATE_USER_DATA,
    UPDATE_TENANT_DATA,
    SET_USER_OCCUPANCIES,
    SET_ADMIN_STATUS,
    APP_SHOW_ERROR_PAGE,
    APP_SET_PLAYLISTS,
    APP_SET_PROPERTY_PLAYLISTS,
    UPDATE_USER_ROLES,
    SET_TRAINING_RESULTS,
    APP_SET_LOADING,
    SET_TERMS_ACCEPTED,
    SHOW_TERMS_OF_USE
} from '../actionTypes'

const defaultState = {
    errorMsg: null,
    isLoading: true,
    isAdmin: false,
    adminMode: false,
    building: {},
    property: {},
    tenant: {},
    client: {},
    user: {
        attributes: {},
        userGroups: {},
    },
    floorWardens: null,
    search: null,
    showUpdateAttributes: false,
    showBuildingPicker: false,
    height: 0,
    width: 0,
    occupancies: [],
    playlists: [],
    propertyPlaylists: null,
    termsAccepted: false,
    showTermsOfUse: false,
}

const appReducer = (state = defaultState, action) => {
    switch (action.type) {
        case APP_SET_LOADING:
            return {
                ...state,
                isLoading: action.value
            }
        case SET_ADMIN_STATUS:
            return {
                ...state,
                isAdmin: action.admin,
            }
        case APP_SET_SEARCH:
            return {
                ...state,
                search: action.value,
            }

        case APP_UPDATE_ATTRIBUTE:
            return {
                ...state,
                user: {
                    ...state.user,
                    attributes: {
                        ...state.user.attributes,
                        [action.attr]: action.val,
                    },
                },
            }

        case HANDLE_CHANGE:
            return { ...state, [action.name]: action.event.target.value }

        case SET_USER_ATTRIBUTES:
            return {
                ...state,
                user: {
                    attributes: action.data,
                    userGroups: action.user.signInUserSession.idToken.payload['cognito:groups'],
                },
                adminMode: action.admin,
            }

        case SET_USER_DATA:
            return {
                ...state,
                building: action.data.building,
                property: action.data.property,
                tenant: action.data.tenant,
                client: action.data.client,
                user: {
                    ...state.user,
                    userId: action.data.userId,
                    userD1: action.data.d1,
                    d2: action.data.d2,
                    sk: action.data.sk,
                    firstName: action.data.firstName,
                    lastName: action.data.lastName,
                    workPhone: action.data.workPhone,
                    phoneNumber: action.data.phoneNumber,
                    floor: action.data.floor,
                    floorWarden: action.data.floorWarden,
                    roles: action.data.roles,
                    suite: action.data.suite,
                    version: action.data.version,
                    email: action.data.email,
                    extraFields: action.data.extraFields,
                    haveLoggedIn: action.data.haveLoggedIn,
                    termsAcceptanceDate: action.data.termsAcceptanceDate
                },
                isLoading: false,
            }

        case SHOW_UPDATE_ATTRIBUTES:
            return { ...state, showUpdateAttributes: action.show }

        case SET_TRAINING_RESULTS:
            return {
                ...state,
                trainingResults: action.trainingResults
            }
        case UPDATE_TRAINING_RESULT:

            return {
                ...state,
                trainingResults: [
                    ...state.trainingResults.filter((result) => result.sk.split('#')[1] !== action.newResult.sk.split('#')[1]),
                    {
                        ...action.newResult
                    },
                ],
            }

        case UPDATE_WINDOW_DIMENSIONS:
            return {
                ...state,
                width: action.width,
                height: action.height,
            }

        case UPDATE_BUILDING_DATA:
            return {
                ...state,
                building: {
                    ...state.building,
                    ...action.data,
                },
            }
        case UPDATE_TENANT_DATA:
            return {
                ...state,
                tenant: {
                    ...state.tenant,
                    ...action.data,
                },
            }

        case SHOW_BUILDING_PICKER:
            return {
                ...state,
                showBuildingPicker: action.show,
            }

        case SET_USER_OCCUPANCIES:
            return {
                ...state,
                occupancies: action.data
            }

        case APP_TOGGLE_ADMIN_MODE: {
            return {
                ...state,
                adminMode: !state.adminMode,
                localMode: action.localStatus,
            }
        }

        case UPDATE_USER_DATA: {
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.data,
                    floor: action.data.d1.split("#")[5],
                    suite: action.data.d1.split("#")[6]
                },
            }
        }
        case UPDATE_USER_ROLES: {
            return {
                ...state,
                user: {
                    ...state.user,
                    roles: action.roles,
                },
            }
        }
        case APP_SHOW_ERROR_PAGE:
            return {
                ...state,
                showErrorPage: action.show,
            }
        case APP_SET_PLAYLISTS:
            return {
                ...state,
                playlists: action.playlists,
            }
        case APP_SET_PROPERTY_PLAYLISTS:
            return {
                ...state,
                propertyPlaylists: action.playlists,
            }
        case SET_TERMS_ACCEPTED:
            return {
                ...state,
                termsAccepted: action.payload
            }

        case SHOW_TERMS_OF_USE:
            return {
                ...state,
                showTermsOfUse: action.payload
            }

        default:
            return state
    }
}

export default appReducer
